// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate:marketing` to regenerate.

import { lazy, Suspense } from 'react';
import type { ReactNode } from 'react';
import { MarketingPage } from '@inferrex/ui/marketing';

const HomePage = lazy(async () => {
  const { HOME_BLOCKS } = await import('../manifests/generated/home-blocks');
  return { default: () => <MarketingPage spec={HOME_BLOCKS} /> };
});
const FunctionalityPage = lazy(async () => {
  const { FUNCTIONALITY_BLOCKS } = await import('../manifests/generated/functionality-blocks');
  return { default: () => <MarketingPage spec={FUNCTIONALITY_BLOCKS} /> };
});
const TechnicalPage = lazy(async () => {
  const { TECHNICAL_BLOCKS } = await import('../manifests/generated/technical-blocks');
  return { default: () => <MarketingPage spec={TECHNICAL_BLOCKS} /> };
});
const IntelligencePage = lazy(async () => {
  const { INTELLIGENCE_BLOCKS } = await import('../manifests/generated/intelligence-blocks');
  return { default: () => <MarketingPage spec={INTELLIGENCE_BLOCKS} /> };
});
const UniversePage = lazy(async () => {
  const { UNIVERSE_BLOCKS } = await import('../manifests/generated/universe-blocks');
  return { default: () => <MarketingPage spec={UNIVERSE_BLOCKS} /> };
});
const SubmitApiPage = lazy(async () => {
  const { SUBMIT_API_BLOCKS } = await import('../manifests/generated/submit-api-blocks');
  return { default: () => <MarketingPage spec={SUBMIT_API_BLOCKS} /> };
});
const CompliancePage = lazy(async () => {
  const { COMPLIANCE_BLOCKS } = await import('../manifests/generated/compliance-blocks');
  return { default: () => <MarketingPage spec={COMPLIANCE_BLOCKS} /> };
});
const PricingPage = lazy(async () => {
  const { PRICING_BLOCKS } = await import('../manifests/generated/pricing-blocks');
  return { default: () => <MarketingPage spec={PRICING_BLOCKS} /> };
});
const ComparePage = lazy(async () => {
  const { COMPARE_BLOCKS } = await import('../manifests/generated/compare-blocks');
  return { default: () => <MarketingPage spec={COMPARE_BLOCKS} /> };
});
const MulesoftAlternativePage = lazy(async () => {
  const { MULESOFT_ALTERNATIVE_BLOCKS } = await import('../manifests/generated/mulesoft-alternative-blocks');
  return { default: () => <MarketingPage spec={MULESOFT_ALTERNATIVE_BLOCKS} /> };
});
const BoomiAlternativePage = lazy(async () => {
  const { BOOMI_ALTERNATIVE_BLOCKS } = await import('../manifests/generated/boomi-alternative-blocks');
  return { default: () => <MarketingPage spec={BOOMI_ALTERNATIVE_BLOCKS} /> };
});
const WorkatoAlternativePage = lazy(async () => {
  const { WORKATO_ALTERNATIVE_BLOCKS } = await import('../manifests/generated/workato-alternative-blocks');
  return { default: () => <MarketingPage spec={WORKATO_ALTERNATIVE_BLOCKS} /> };
});
const DocsPage = lazy(async () => {
  const { DOCS_BLOCKS } = await import('../manifests/generated/docs-blocks');
  return { default: () => <MarketingPage spec={DOCS_BLOCKS} /> };
});
const DocsQuickstartPage = lazy(async () => {
  const { DOCS_QUICKSTART_BLOCKS } = await import('../manifests/generated/docs-quickstart-blocks');
  return { default: () => <MarketingPage spec={DOCS_QUICKSTART_BLOCKS} /> };
});
const DocsApiReferencePage = lazy(async () => {
  const { API_REFERENCE_BLOCKS } = await import('../manifests/generated/api-reference-blocks');
  return { default: () => <MarketingPage spec={API_REFERENCE_BLOCKS} /> };
});
const DocsApiChangelogPage = lazy(async () => {
  const { API_CHANGELOG_BLOCKS } = await import('../manifests/generated/api-changelog-blocks');
  return { default: () => <MarketingPage spec={API_CHANGELOG_BLOCKS} /> };
});
const DocsSdkPage = lazy(async () => {
  const { DOCS_SDK_BLOCKS } = await import('../manifests/generated/docs-sdk-blocks');
  return { default: () => <MarketingPage spec={DOCS_SDK_BLOCKS} /> };
});
const DocsMcpPage = lazy(async () => {
  const { DOCS_MCP_BLOCKS } = await import('../manifests/generated/docs-mcp-blocks');
  return { default: () => <MarketingPage spec={DOCS_MCP_BLOCKS} /> };
});
const CorpusPage = lazy(async () => {
  const { CORPUS_BLOCKS } = await import('../manifests/generated/corpus-blocks');
  return { default: () => <MarketingPage spec={CORPUS_BLOCKS} /> };
});
const AboutPage = lazy(async () => {
  const { ABOUT_BLOCKS } = await import('../manifests/generated/about-blocks');
  return { default: () => <MarketingPage spec={ABOUT_BLOCKS} /> };
});
const LinguaFrancaPage = lazy(async () => {
  const { LINGUA_FRANCA_BLOCKS } = await import('../manifests/generated/lingua-franca-blocks');
  return { default: () => <MarketingPage spec={LINGUA_FRANCA_BLOCKS} /> };
});
const ManifestoPage = lazy(async () => {
  const { MANIFESTO_BLOCKS } = await import('../manifests/generated/manifesto-blocks');
  return { default: () => <MarketingPage spec={MANIFESTO_BLOCKS} /> };
});
const InsightsPage = lazy(async () => {
  const { INSIGHTS_BLOCKS } = await import('../manifests/generated/insights-blocks');
  return { default: () => <MarketingPage spec={INSIGHTS_BLOCKS} /> };
});
const InsightsTheStateCannotSeeItselfPage = lazy(async () => {
  const { INSIGHTS_STATE_BLOCKS } = await import('../manifests/generated/insights-the-state-cannot-see-itself-blocks');
  return { default: () => <MarketingPage spec={INSIGHTS_STATE_BLOCKS} /> };
});
const InsightsComprehensionOverConnectionPage = lazy(async () => {
  const { INSIGHTS_COMPREHENSION_OVER_CONNECTION_BLOCKS } = await import('../manifests/generated/insights-comprehension-over-connection-blocks');
  return { default: () => <MarketingPage spec={INSIGHTS_COMPREHENSION_OVER_CONNECTION_BLOCKS} /> };
});
const InsightsTheNxnProblemPage = lazy(async () => {
  const { INSIGHTS_NXN_PROBLEM_BLOCKS } = await import('../manifests/generated/insights-the-nxn-problem-blocks');
  return { default: () => <MarketingPage spec={INSIGHTS_NXN_PROBLEM_BLOCKS} /> };
});
const InsightsLinguaFrancaForBusinessDataPage = lazy(async () => {
  const { INSIGHTS_LINGUA_FRANCA_DATA_BLOCKS } = await import('../manifests/generated/insights-lingua-franca-for-business-data-blocks');
  return { default: () => <MarketingPage spec={INSIGHTS_LINGUA_FRANCA_DATA_BLOCKS} /> };
});
const InsightsEveryoneCanBeDifferentPage = lazy(async () => {
  const { INSIGHTS_EVERYONE_DIFFERENT_BLOCKS } = await import('../manifests/generated/insights-everyone-can-be-different-blocks');
  return { default: () => <MarketingPage spec={INSIGHTS_EVERYONE_DIFFERENT_BLOCKS} /> };
});
const InsightsSelfHealingIntegrationPage = lazy(async () => {
  const { INSIGHTS_SELF_HEALING_BLOCKS } = await import('../manifests/generated/insights-self-healing-integration-blocks');
  return { default: () => <MarketingPage spec={INSIGHTS_SELF_HEALING_BLOCKS} /> };
});
const InsightsHiddenCostBrittleIntegrationsPage = lazy(async () => {
  const { INSIGHTS_HIDDEN_COST_BLOCKS } = await import('../manifests/generated/insights-hidden-cost-brittle-integrations-blocks');
  return { default: () => <MarketingPage spec={INSIGHTS_HIDDEN_COST_BLOCKS} /> };
});
const InsightsInferringApiStructurePage = lazy(async () => {
  const { INSIGHTS_INFERRING_API_BLOCKS } = await import('../manifests/generated/insights-inferring-api-structure-blocks');
  return { default: () => <MarketingPage spec={INSIGHTS_INFERRING_API_BLOCKS} /> };
});
const InsightsSovereignIntegrationInfrastructurePage = lazy(async () => {
  const { INSIGHTS_SOVEREIGN_INFRA_BLOCKS } = await import('../manifests/generated/insights-sovereign-integration-infrastructure-blocks');
  return { default: () => <MarketingPage spec={INSIGHTS_SOVEREIGN_INFRA_BLOCKS} /> };
});
const InsightsAirGappedNotCrippledPage = lazy(async () => {
  const { INSIGHTS_AIR_GAPPED_BLOCKS } = await import('../manifests/generated/insights-air-gapped-not-crippled-blocks');
  return { default: () => <MarketingPage spec={INSIGHTS_AIR_GAPPED_BLOCKS} /> };
});
const InsightsSaasToCriticalInfrastructurePage = lazy(async () => {
  const { INSIGHTS_SAAS_TO_INFRA_BLOCKS } = await import('../manifests/generated/insights-saas-to-critical-infrastructure-blocks');
  return { default: () => <MarketingPage spec={INSIGHTS_SAAS_TO_INFRA_BLOCKS} /> };
});
const InsightsDataSovereigntyRegulatedIndustriesPage = lazy(async () => {
  const { INSIGHTS_DATA_SOVEREIGNTY_BLOCKS } = await import('../manifests/generated/insights-data-sovereignty-regulated-industries-blocks');
  return { default: () => <MarketingPage spec={INSIGHTS_DATA_SOVEREIGNTY_BLOCKS} /> };
});
const InsightsOnePersonProductionInfrastructurePage = lazy(async () => {
  const { INSIGHTS_ONE_PERSON_BLOCKS } = await import('../manifests/generated/insights-one-person-production-infrastructure-blocks');
  return { default: () => <MarketingPage spec={INSIGHTS_ONE_PERSON_BLOCKS} /> };
});
const InsightsSelfSovereignAiTrainingPage = lazy(async () => {
  const { INSIGHTS_SELF_SOVEREIGN_AI_BLOCKS } = await import('../manifests/generated/insights-self-sovereign-ai-training-blocks');
  return { default: () => <MarketingPage spec={INSIGHTS_SELF_SOVEREIGN_AI_BLOCKS} /> };
});
const InsightsOwnAiLayerPage = lazy(async () => {
  const { INSIGHTS_OWN_AI_LAYER_BLOCKS } = await import('../manifests/generated/insights-own-ai-layer-blocks');
  return { default: () => <MarketingPage spec={INSIGHTS_OWN_AI_LAYER_BLOCKS} /> };
});
const InsightsEmbeddedIntegrationInfrastructurePage = lazy(async () => {
  const { INSIGHTS_EMBEDDED_INFRA_BLOCKS } = await import('../manifests/generated/insights-embedded-integration-infrastructure-blocks');
  return { default: () => <MarketingPage spec={INSIGHTS_EMBEDDED_INFRA_BLOCKS} /> };
});
const InsightsInferrexVsIpaasPage = lazy(async () => {
  const { INSIGHTS_VS_IPAAS_BLOCKS } = await import('../manifests/generated/insights-inferrex-vs-ipaas-blocks');
  return { default: () => <MarketingPage spec={INSIGHTS_VS_IPAAS_BLOCKS} /> };
});
const InsightsApiSchemaCorpusPage = lazy(async () => {
  const { INSIGHTS_API_SCHEMA_CORPUS_BLOCKS } = await import('../manifests/generated/insights-api-schema-corpus-blocks');
  return { default: () => <MarketingPage spec={INSIGHTS_API_SCHEMA_CORPUS_BLOCKS} /> };
});
const PartnersPage = lazy(async () => {
  const { PARTNERS_BLOCKS } = await import('../manifests/generated/partners-blocks');
  return { default: () => <MarketingPage spec={PARTNERS_BLOCKS} /> };
});
const FounderPage = lazy(async () => {
  const { FOUNDER_BLOCKS } = await import('../manifests/generated/founder-blocks');
  return { default: () => <MarketingPage spec={FOUNDER_BLOCKS} /> };
});
const ClaimsPage = lazy(async () => {
  const { CLAIMS_BLOCKS } = await import('../manifests/generated/claims-blocks');
  return { default: () => <MarketingPage spec={CLAIMS_BLOCKS} /> };
});
const DemoPage = lazy(async () => {
  const { DEMO_BLOCKS } = await import('../manifests/generated/demo-blocks');
  return { default: () => <MarketingPage spec={DEMO_BLOCKS} /> };
});
const ContactPage = lazy(async () => {
  const { CONTACT_BLOCKS } = await import('../manifests/generated/contact-blocks');
  return { default: () => <MarketingPage spec={CONTACT_BLOCKS} /> };
});
const LegalTermsPage = lazy(async () => {
  const { TERMS_BLOCKS } = await import('../manifests/generated/legal-terms-blocks');
  return { default: () => <MarketingPage spec={TERMS_BLOCKS} /> };
});
const LegalPrivacyPage = lazy(async () => {
  const { PRIVACY_BLOCKS } = await import('../manifests/generated/legal-privacy-blocks');
  return { default: () => <MarketingPage spec={PRIVACY_BLOCKS} /> };
});
const LegalDpaPage = lazy(async () => {
  const { DPA_BLOCKS } = await import('../manifests/generated/legal-dpa-blocks');
  return { default: () => <MarketingPage spec={DPA_BLOCKS} /> };
});
const LegalCookiesPage = lazy(async () => {
  const { COOKIES_BLOCKS } = await import('../manifests/generated/legal-cookies-blocks');
  return { default: () => <MarketingPage spec={COOKIES_BLOCKS} /> };
});
const LegalAcceptableUsePage = lazy(async () => {
  const { ACCEPTABLE_USE_BLOCKS } = await import('../manifests/generated/legal-acceptable-use-blocks');
  return { default: () => <MarketingPage spec={ACCEPTABLE_USE_BLOCKS} /> };
});
const LegalSubprocessorsPage = lazy(async () => {
  const { SUBPROCESSORS_BLOCKS } = await import('../manifests/generated/legal-subprocessors-blocks');
  return { default: () => <MarketingPage spec={SUBPROCESSORS_BLOCKS} /> };
});
const LegalSecurityPage = lazy(async () => {
  const { SECURITY_BLOCKS } = await import('../manifests/generated/legal-security-blocks');
  return { default: () => <MarketingPage spec={SECURITY_BLOCKS} /> };
});

export interface AppRoute {
  readonly path: string;
  readonly element: ReactNode;
}

export const routes: readonly AppRoute[] = [
  { path: '/', element: <Suspense fallback={null}><HomePage /></Suspense> },
  { path: '/functionality', element: <Suspense fallback={null}><FunctionalityPage /></Suspense> },
  { path: '/technical', element: <Suspense fallback={null}><TechnicalPage /></Suspense> },
  { path: '/intelligence', element: <Suspense fallback={null}><IntelligencePage /></Suspense> },
  { path: '/universe', element: <Suspense fallback={null}><UniversePage /></Suspense> },
  { path: '/submit-api', element: <Suspense fallback={null}><SubmitApiPage /></Suspense> },
  { path: '/compliance', element: <Suspense fallback={null}><CompliancePage /></Suspense> },
  { path: '/pricing', element: <Suspense fallback={null}><PricingPage /></Suspense> },
  { path: '/compare', element: <Suspense fallback={null}><ComparePage /></Suspense> },
  { path: '/mulesoft-alternative', element: <Suspense fallback={null}><MulesoftAlternativePage /></Suspense> },
  { path: '/boomi-alternative', element: <Suspense fallback={null}><BoomiAlternativePage /></Suspense> },
  { path: '/workato-alternative', element: <Suspense fallback={null}><WorkatoAlternativePage /></Suspense> },
  { path: '/docs', element: <Suspense fallback={null}><DocsPage /></Suspense> },
  { path: '/docs/quickstart', element: <Suspense fallback={null}><DocsQuickstartPage /></Suspense> },
  { path: '/docs/api-reference', element: <Suspense fallback={null}><DocsApiReferencePage /></Suspense> },
  { path: '/docs/api-changelog', element: <Suspense fallback={null}><DocsApiChangelogPage /></Suspense> },
  { path: '/docs/sdk', element: <Suspense fallback={null}><DocsSdkPage /></Suspense> },
  { path: '/docs/mcp', element: <Suspense fallback={null}><DocsMcpPage /></Suspense> },
  { path: '/corpus', element: <Suspense fallback={null}><CorpusPage /></Suspense> },
  { path: '/about', element: <Suspense fallback={null}><AboutPage /></Suspense> },
  { path: '/lingua-franca', element: <Suspense fallback={null}><LinguaFrancaPage /></Suspense> },
  { path: '/manifesto', element: <Suspense fallback={null}><ManifestoPage /></Suspense> },
  { path: '/insights', element: <Suspense fallback={null}><InsightsPage /></Suspense> },
  { path: '/insights/the-state-cannot-see-itself', element: <Suspense fallback={null}><InsightsTheStateCannotSeeItselfPage /></Suspense> },
  { path: '/insights/comprehension-over-connection', element: <Suspense fallback={null}><InsightsComprehensionOverConnectionPage /></Suspense> },
  { path: '/insights/the-nxn-problem', element: <Suspense fallback={null}><InsightsTheNxnProblemPage /></Suspense> },
  { path: '/insights/lingua-franca-for-business-data', element: <Suspense fallback={null}><InsightsLinguaFrancaForBusinessDataPage /></Suspense> },
  { path: '/insights/everyone-can-be-different', element: <Suspense fallback={null}><InsightsEveryoneCanBeDifferentPage /></Suspense> },
  { path: '/insights/self-healing-integration', element: <Suspense fallback={null}><InsightsSelfHealingIntegrationPage /></Suspense> },
  { path: '/insights/hidden-cost-brittle-integrations', element: <Suspense fallback={null}><InsightsHiddenCostBrittleIntegrationsPage /></Suspense> },
  { path: '/insights/inferring-api-structure', element: <Suspense fallback={null}><InsightsInferringApiStructurePage /></Suspense> },
  { path: '/insights/sovereign-integration-infrastructure', element: <Suspense fallback={null}><InsightsSovereignIntegrationInfrastructurePage /></Suspense> },
  { path: '/insights/air-gapped-not-crippled', element: <Suspense fallback={null}><InsightsAirGappedNotCrippledPage /></Suspense> },
  { path: '/insights/saas-to-critical-infrastructure', element: <Suspense fallback={null}><InsightsSaasToCriticalInfrastructurePage /></Suspense> },
  { path: '/insights/data-sovereignty-regulated-industries', element: <Suspense fallback={null}><InsightsDataSovereigntyRegulatedIndustriesPage /></Suspense> },
  { path: '/insights/one-person-production-infrastructure', element: <Suspense fallback={null}><InsightsOnePersonProductionInfrastructurePage /></Suspense> },
  { path: '/insights/self-sovereign-ai-training', element: <Suspense fallback={null}><InsightsSelfSovereignAiTrainingPage /></Suspense> },
  { path: '/insights/own-ai-layer', element: <Suspense fallback={null}><InsightsOwnAiLayerPage /></Suspense> },
  { path: '/insights/embedded-integration-infrastructure', element: <Suspense fallback={null}><InsightsEmbeddedIntegrationInfrastructurePage /></Suspense> },
  { path: '/insights/inferrex-vs-ipaas', element: <Suspense fallback={null}><InsightsInferrexVsIpaasPage /></Suspense> },
  { path: '/insights/api-schema-corpus', element: <Suspense fallback={null}><InsightsApiSchemaCorpusPage /></Suspense> },
  { path: '/partners', element: <Suspense fallback={null}><PartnersPage /></Suspense> },
  { path: '/founder', element: <Suspense fallback={null}><FounderPage /></Suspense> },
  { path: '/claims', element: <Suspense fallback={null}><ClaimsPage /></Suspense> },
  { path: '/demo', element: <Suspense fallback={null}><DemoPage /></Suspense> },
  { path: '/contact', element: <Suspense fallback={null}><ContactPage /></Suspense> },
  { path: '/legal/terms', element: <Suspense fallback={null}><LegalTermsPage /></Suspense> },
  { path: '/legal/privacy', element: <Suspense fallback={null}><LegalPrivacyPage /></Suspense> },
  { path: '/legal/dpa', element: <Suspense fallback={null}><LegalDpaPage /></Suspense> },
  { path: '/legal/cookies', element: <Suspense fallback={null}><LegalCookiesPage /></Suspense> },
  { path: '/legal/acceptable-use', element: <Suspense fallback={null}><LegalAcceptableUsePage /></Suspense> },
  { path: '/legal/subprocessors', element: <Suspense fallback={null}><LegalSubprocessorsPage /></Suspense> },
  { path: '/legal/security', element: <Suspense fallback={null}><LegalSecurityPage /></Suspense> },
];
